import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, ToastType } from 'app/server/helpers/toast.service';

const COLOR: Record<ToastType, string> = { show: 'secondary', success: 'success', error: 'danger', info: 'info', warning: 'warning' };

/** Contenitore globale dei messaggi (ngb-toast), in basso al centro come prima con ngx-toastr. */
@Component({
	selector: 'app-toast-container',
	standalone: true,
	imports: [NgbToastModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'toast-container position-fixed bottom-0 start-50 translate-middle-x p-1', style: 'z-index: 1200' },
	template: `
		@for (toast of toastService.toasts(); track toast.id) {
			<ngb-toast
				class="bg-white mb-1 border-start border-4"
				[class]="'border-' + color(toast.type)"
				[autohide]="true"
				[delay]="5000"
				role="alert"
				(hidden)="toastService.remove(toast.id)">
				<div class="d-flex align-items-start">
					<div class="flex-grow-1">
						@if (toast.title) {
							<strong class="d-block" [class]="'text-' + color(toast.type)">{{ toast.title }}</strong>
						}
						<span>{{ toast.message }}</span>
					</div>
					@if (toast.closable) {
						<button type="button" class="btn-close ms-1" aria-label="Close" (click)="toastService.remove(toast.id)"></button>
					}
				</div>
			</ngb-toast>
		}
	`,
})
export class ToastContainerComponent {
	readonly toastService = inject(ToastService);

	color(type: ToastType): string {
		return COLOR[type];
	}
}
